
<Popup
  :visible="visible"
  :teleport="teleport"
  position="center"
  :close-on-click-overlay="false"
  :class="classes(n('wrapper'))"
  @update:visible="onUpdateVisible"
>
  <div :class="classes(n(), n(`--${theme}`))">
    <!-- 内容区域 -->
    <div :class="n('content')">
      <!-- 标题插槽 -->
      <div
        v-if="$slots.title || title"
        :class="n('title')"
      >
        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <!-- 内容插槽 -->
      <div
        v-if="$slots.default || content"
        :class="[
          n('message'),
          { [n('message--no-title')]: !$slots.title && !title },
        ]"
      >
        <slot>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="content" />
        </slot>
      </div>
    </div>

    <!-- 操作按钮区域 -->
    <div
      v-if="$slots.actions || actions.length > 0"
      :class="[
        n('actions'),
        n(`actions--${computedButtonLayout}`),
      ]"
    >
      <slot name="actions">
        <div
          v-for="(action, index) in actions"
          :key="index"
          :class="[
            n('action'),
            n(`action--${getActionType(index)}`),
          ]"
          @click="handleActionClick(action, index)"
        >
          {{ action.text }}
        </div>
      </slot>
    </div>
  </div>
</Popup>
